export default __webpack_public_path__ + "static/media/RACECRAFT.a67f794b.webp";